import { render, staticRenderFns } from "./AuthorAutocomplete.vue?vue&type=template&id=1abf8b88&"
import script from "./AuthorAutocomplete.vue?vue&type=script&lang=js&"
export * from "./AuthorAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports